import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons'

function ErrorEmailTaken({errorMessage = ""}) {

	const defaultMessage = `The user email has already been taken.`;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				padding: '13px',
				borderRadius: '8px',
				marginRight: 'auto',
				backgroundColor: 'rgba(243, 119, 119, 0.4)',
				color: 'rgb(165 0 0)',
			}}
		>
			<FontAwesomeIcon
				icon={faExclamationTriangle}
				style={{
					marginRight: 10,
				}}
			/>
			<div>
				{/* <span>{challengeState.errors['user_email']}</span> */}
				<span>{errorMessage || defaultMessage}</span>
				<p
					style={{
						fontSize: 13,
						marginTop: 5,
					}}
				>
					Already have an account?{' '}
					<a
						href="https://masterchallenge.me/login"
						target="_blank"
						rel="noreferrer"
						style={{
							color: 'purple',
						}}
					>
						Login
					</a>
				</p>
			</div>
		</div>
	)
}

export default ErrorEmailTaken